/* Filtrous PDP COMPARISON TABLE - v1, 2026-09-02 (Adelaide).

   Puts the family's category comparison table on the product page, between
   "Products related to this item" and "Recommended For You":

     [ Specifications | Description ] tabs
     Frequently bought together              (filtrous-fbt.js)
     Products related to this item           (filtrous-fbt.js)
     How these compare                       (THIS FILE)
     Recommended For You                     (filtrous-pdp-merch.js)
     Recently viewed                         (filtrous-recently-viewed.js)

   The sequence itself is CSS `order` and lives in ONE place - the fbt-css
   block in assets/filtrous-fbt.js (.fv3-cmp is order 4 there). Never move
   these sections with DOM writes: filtrous-pdp-merch.js re-inserts its own
   rail on every observer pass, and the two modules ping-pong.

   WHERE THE TABLE COMES FROM: assets/filtrous-compare-tables.js publishes
   window.FV3_COMPARE, keyed on primary_family and lifted verbatim from the
   `comparison` blocks on the collection templates. So the block is a FAMILY
   asset, not a per-SKU one - every glove SKU shows the nitrile/latex/vinyl
   table with no tagging, and a new SKU inherits it the day it lands in
   catalog-index.json. 61 of 86 families have a table; the rest render
   nothing at all (no heading, no empty frame).

   The family comes from the catalog index via the same read-only fetch tap
   the other shims use, so this file must load NON-deferred (the tap has to be
   installed before the deferred app requests the index).

   Additive asset; remove its loader line in sections/filtrous-v3-app.liquid
   to revert (and the .fv3-cmp order rule in filtrous-fbt.js becomes inert -
   the remaining orders still sort correctly with the gap). */
(function () {
  'use strict';

  var HEADING = 'How these compare';

  /* ---- catalog index: read-only tap, same pattern as the other shims ---- */
  var IDX = null, BY_SKU = {};
  var orig = window.fetch;
  if (orig) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (String(url).indexOf('catalog-index') === -1) return p;
      return p.then(function (res) {
        if (res && res.ok) {
          /* clone() throws synchronously once the body has been read, and a
             throw here would reject the index promise for the whole app. */
          var c = null;
          try { c = res.clone(); } catch (e) { return res; }
          c.json().then(function (d) {
            IDX = d;
            (d.products || []).forEach(function (x) {
              if (x && x.sku) BY_SKU[String(x.sku).toUpperCase()] = x;
            });
            schedule();
          }).catch(function () {});
        }
        return res;
      });
    };
  }

  function familyFor(sku) {
    var p = BY_SKU[String(sku || '').toUpperCase()];
    return (p && p.primary_family) || '';
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m];
    });
  }

  /* ---------------- build ---------------- */
  function build(pdp) {
    var sku = (window.FV3_CONFIG && window.FV3_CONFIG.pdpSku) || '';
    if (!sku || !IDX) return false;

    var have = pdp.querySelector('.fv3-cmp');
    if (have && have.getAttribute('data-sku') === String(sku).toUpperCase()) return false;

    var TABLES = window.FV3_COMPARE;
    if (!TABLES) return false;
    var row = TABLES[familyFor(sku)];
    /* No table for this family - render nothing rather than an empty frame. */
    if (!row || !row.table_html) { if (have) have.parentNode.removeChild(have); return !!have; }

    var sec = have || document.createElement('section');
    sec.className = 'fv3-cmp';
    sec.setAttribute('data-sku', String(sku).toUpperCase());
    sec.setAttribute('aria-label', HEADING);
    sec.innerHTML =
      '<div class="fv3-rv-head"><h2>' + esc(HEADING) + '</h2></div>' +
      (row.label ? '<div class="fv3-cmp-label">' + esc(row.label) + '</div>' : '') +
      (row.title ? '<p class="fv3-cmp-title">' + esc(row.title) + '</p>' : '') +
      '<div class="fv3-cmp-wrap">' + row.table_html + '</div>';
    if (!sec.isConnected) pdp.appendChild(sec);
    return true;
  }

  if (!document.getElementById('fv3-cmp-css')) {
    var st = document.createElement('style');
    st.id = 'fv3-cmp-css';
    st.textContent =
      /* Section chrome matches .fv3-fbt / .fv3-rel in filtrous-fbt.js - the
         lower PDP is one rhythm, 44px rule to rule. Side padding comes from
         .fv3-pdp, so this block adds none of its own. */
      '#fv3-app .fv3-pdp>.fv3-cmp{margin:44px 0 8px;border-top:1px solid var(--line,#e3e9ee);padding:22px 0 0;}' +
      '#fv3-app .fv3-cmp .fv3-cmp-label{font-size:11px;font-weight:700;letter-spacing:.12em;text-transform:uppercase;color:var(--mut,#5c6f7e);margin:2px 0 0;}' +
      '#fv3-app .fv3-cmp .fv3-cmp-title{margin:4px 0 14px;font-size:15px;color:var(--ink,#12222f);}' +
      /* Wide tables scroll inside their own box; the page never does. */
      '#fv3-app .fv3-cmp .fv3-cmp-wrap{width:100%;overflow-x:auto;border:1px solid var(--line,#e3e9ee);border-radius:10px;background:#fff;}' +
      '#fv3-app .fv3-cmp table{width:100%;min-width:520px;border-collapse:collapse;font-size:13.5px;line-height:1.45;margin:0;}' +
      '#fv3-app .fv3-cmp thead th{background:var(--panel,#f7fafb);color:var(--navy,#082f4b);font-weight:700;font-size:12.5px;text-align:left;white-space:nowrap;padding:11px 14px;border-bottom:1px solid var(--line,#e3e9ee);}' +
      '#fv3-app .fv3-cmp td,#fv3-app .fv3-cmp tbody th{padding:11px 14px;text-align:left;vertical-align:top;color:var(--ink,#12222f);border-bottom:1px solid rgba(8,47,75,.07);}' +
      '#fv3-app .fv3-cmp tbody tr:last-child td,#fv3-app .fv3-cmp tbody tr:last-child th{border-bottom:0;}' +
      '#fv3-app .fv3-cmp tbody tr:nth-child(even){background:#fafbfc;}' +
      '#fv3-app .fv3-cmp tbody td:first-child,#fv3-app .fv3-cmp tbody th:first-child{color:var(--navy,#082f4b);}' +
      '#fv3-app .fv3-cmp tbody td:first-child strong,#fv3-app .fv3-cmp tbody th:first-child strong{font-weight:700;}' +
      '@media (max-width:820px){#fv3-app .fv3-pdp>.fv3-cmp{margin:32px 0 8px;padding:18px 0 0;}' +
      '#fv3-app .fv3-cmp table{font-size:13px;}' +
      '#fv3-app .fv3-cmp td,#fv3-app .fv3-cmp tbody th,#fv3-app .fv3-cmp thead th{padding:10px 12px;}}';
    document.head.appendChild(st);
  }

  /* Observer is DISCONNECTED while we write so our own mutations never
     re-enter, and passes are coalesced instead of firing per record. Same
     shape as filtrous-fbt.js, including the IDX gate on the give-up counter:
     passes before the index resolves cannot change anything, and the app's
     boot churn alone runs more than 30 of them. */
  var obs = null, queued = false, idle = 0, lastKey = '';
  function host() { return document.getElementById('fv3-app') || document.body; }
  function connect() {
    if (!obs) obs = new MutationObserver(schedule);
    obs.observe(host(), { childList: true, subtree: true });
  }
  function guarded() {
    var key = location.pathname + location.hash + '|' + ((window.FV3_CONFIG || {}).pdpSku || '');
    if (key !== lastKey) { lastKey = key; idle = 0; }
    if (IDX && idle > 30) { if (obs) obs.disconnect(); return; }
    if (obs) obs.disconnect();
    var changed = false;
    try {
      var pdp = document.querySelector('#fv3-app .fv3-pdp');
      if (pdp) changed = build(pdp);
    } catch (e) {} finally { connect(); }
    if (changed) idle = 0; else if (IDX) idle++;
  }
  function schedule() {
    if (queued) return;
    queued = true;
    /* setTimeout, NOT requestAnimationFrame: rAF does not fire in a hidden
       tab, which would leave `queued` stuck true forever. */
    setTimeout(function () { queued = false; guarded(); }, 16);
  }
  function boot() { guarded(); connect(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('hashchange', schedule);
})();
